export class EsbContractModel {
    static RETURN = 'RETURN';
    static DELIVERY = 'DELIVERY';
    static EXCHANGE1 = 'EXCHANGE1';
    static EXCHANGE2 = 'EXCHANGE2';
    static RETURN_SERVICE_1 = '401981';
    static RETURN_SERVICE_2 = '401982';
    static RETURN_SERVICE_3 = '401983';
    static RETURN_STATUS_RESOLUTION = 'Resolution';
    static RETURN_STATUS_BLACK = 'Black list';
    static RETURN_STATUS_FRAUD = 'Fraud';
    type: string;
    checked: boolean;
    contract_number: string;
    plate: string;
    make: string;
    model: string;
    driver: string;
    vehicle_type: string;
    contract_expiration: string;
    expected_end_date: string;
    start_date: string;
    delivery_location: string;
    flag_preleasing: boolean;
    state: string;
    company: string;
    company_name: string;
    already_imported: boolean;
    can_create_appointment: boolean;
    appointment_id: string;
    return_status: string;
    return_service: string;
    cod_return_service: string;
    pick_up_office_address?: OfficeAddressModel;
    pick_up_office_derogation?: OfficeDerogationModel
}

export interface OfficeAddressModel {
    'city': string;
    'cod_iso_state': string;
    'province': string;
    'region': string;
    'state': string;
    'street': string;
    'street_nr': string;
    'zip': string;
}

export interface OfficeDerogationModel {
    'type': OfficeDerogationType;
    'description': string;
    'value': string;
}

export enum OfficeDerogationType {
    KM_0_15 = 'KM_0_15',
    KM_16_30 = 'KM_16_30',
    OVER_30_KM = 'OVER_30_KM',
    AD_HOC = 'AD_HOC',
}
